export const GET = 'get';
export const HEAD = 'head';
export const POST = 'post';
export const PUT = 'put';
export const DELETE = 'delete';
export const METHODS = [GET, HEAD, POST, PUT, DELETE];



// WEBPACK FOOTER //
// ./app/javascript/requests/methods.js